import React from 'react';
import { Clock, Repeat, AlertCircle, EyeOff, Frown, Battery } from 'lucide-react';
export function CostComparison() {
  const items = [{
    icon: Clock,
    label: '3 hs de planificación × 40 semanas',
    cost: '120 horas de tu vida por año'
  }, {
    icon: AlertCircle,
    label: 'Informes desde cero en diciembre',
    cost: '2 semanas en el peor momento'
  }, {
    icon: Frown,
    label: 'Actos sin plan',
    cost: 'Estrés evitable en cada fecha patria'
  }, {
    icon: Repeat,
    label: 'Material genérico de internet',
    cost: 'El mismo ciclo, el año que viene'
  }];
  return <section className="py-16 md:py-24 px-4 bg-slate-50 border-y border-slate-200" data-id="element-79">
      <div className="max-w-4xl mx-auto" data-id="element-80">
        <div className="text-center mb-10 md:mb-14" data-id="element-81">
          <p className="text-red-500 font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-82">
            ⚖️ El costo real
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto text-slate-900" data-id="element-83">
            ¿Cuánto te cuesta <span className="text-red-500" data-id="element-84">no tenerlo?</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-3 md:gap-4 mb-10" data-id="element-85">
          {items.map(({
          icon: Icon,
          label,
          cost
        }, i) => <div key={i} className="bg-white border border-slate-200 shadow-sm rounded-xl p-4 md:p-5 flex items-start gap-3 hover:border-red-500/30 transition-colors" data-id="element-86">
              <div className="w-9 h-9 rounded-lg bg-red-50 border border-red-100 flex items-center justify-center shrink-0" data-id="element-87">
                <Icon className="w-4 h-4 text-red-500" data-id="element-88" />
              </div>
              <div className="pt-0.5" data-id="element-89">
                <span className="block text-slate-900 text-sm md:text-base font-bold leading-snug mb-1" data-id="element-90">
                  {label}
                </span>
                <span className="block text-slate-500 text-sm font-medium" data-id="element-91">
                  {cost}
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-white border border-primary/20 shadow-sm rounded-2xl p-6 md:p-8 text-center" data-id="element-92">
          <p className="text-base md:text-2xl font-bold text-slate-700 leading-relaxed" data-id="element-93">
            El próximo fin de semana puede ser igual.
            <br data-id="element-94" />
            <span className="text-primary text-lg md:text-3xl" data-id="element-95">
              O puede ser el primero en el que ya no tengas que inventar nada.
            </span>
          </p>
        </div>
      </div>
    </section>;
}